module.exports = __webpack_public_path__ + "static/img/before3.dbddc6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before3.jpg
// module id = 42pH
// module chunks = 9